import { render, staticRenderFns } from "./jianLi.vue?vue&type=template&id=386b6d38&scoped=true"
import script from "./jianLi.vue?vue&type=script&lang=js"
export * from "./jianLi.vue?vue&type=script&lang=js"
import style0 from "./jianLi.vue?vue&type=style&index=0&id=386b6d38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b6d38",
  null
  
)

export default component.exports